import React, { ReactNode, useState } from 'react';
import { ReactEditor, useFocused, useSelected, useSlate } from 'slate-react';
import { Transforms } from 'slate';
import { ButtonGroup } from 'components/_new/ButtonGroup/ButtonGroup';
import { classNames } from 'primereact/utils';
import './Columns.scss';
import { CustomEditor } from '../../types';

type ColumnsProps = {
	children: ReactNode | ReactNode[];
	attributes: any;
	element: any;
};

export enum ColumnsRatio {
	TWO_TO_ONE = '2-1',
	ONE_TO_ONE = '1-1',
	ONE_TO_TWO = '1-2',
}

export const Columns = ({ children, attributes, element }: ColumnsProps) => {
	const editor = useSlate() as CustomEditor;
	const selected = useSelected();
	const focused = useFocused();
	const [ratio, setRatio] = useState<ColumnsRatio>(element.ratio || ColumnsRatio.ONE_TO_TWO);

	const handleRatioChange = (newRatio: ColumnsRatio) => {
		setRatio(newRatio);
		const path = ReactEditor.findPath(editor, element);
		Transforms.setNodes(editor, { ratio: newRatio } as any, { at: path });
		// Transforms.setNodes(editor, { ratio: newRatio } as any, { match: (n: any) => n.type === 'twoColumns' });
	};

	if (Array.isArray(children) && children.length >= 2) {
		return (
			<div className="two-columns">
				{selected && focused && (
					<div className="tools" contentEditable={false}>
						<ButtonGroup
							variant="primary-outlined"
							variantSize="sm"
							buttons={[
								{
									key: ColumnsRatio.TWO_TO_ONE,
									label: '2:1',
									onMouseDown: (event) => {
										event.preventDefault();
										handleRatioChange(ColumnsRatio.TWO_TO_ONE);
									},
								},
								{
									key: ColumnsRatio.ONE_TO_ONE,
									label: '1:1',
									onMouseDown: (event) => {
										event.preventDefault();
										handleRatioChange(ColumnsRatio.ONE_TO_ONE);
									},
								},
								{
									key: ColumnsRatio.ONE_TO_TWO,
									label: '1:2',
									onMouseDown: (event) => {
										event.preventDefault();
										handleRatioChange(ColumnsRatio.ONE_TO_TWO);
									},
								},
							]}
						/>
					</div>
				)}
				<div className="row">
					<div
						className={classNames('column', {
							'column-1': [ColumnsRatio.ONE_TO_ONE, ColumnsRatio.ONE_TO_TWO].includes(ratio),
							'column-2': [ColumnsRatio.TWO_TO_ONE].includes(ratio),
						})}
					>
						{children[0]}
					</div>
					<div
						className={classNames('column', {
							'column-1': [ColumnsRatio.TWO_TO_ONE, ColumnsRatio.ONE_TO_ONE].includes(ratio),
							'column-2': [ColumnsRatio.ONE_TO_TWO].includes(ratio),
						})}
					>
						{children[1]}
					</div>
				</div>
			</div>
		);
	}
	return null;
};
